module.exports = "/images/clouds_dark.png?b762c133d9b4aa72da8db7b53c64eb82";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/clouds_dark.png
// module id = IZo3
// module chunks = 0